/**
 * Accès sûr au `localStorage` : mémoire de confort (préférences, acquittements), jamais une raison
 * de casser un écran. L'accès même à `localStorage` peut lever (stockage bloqué, navigation privée),
 * une lecture peut rendre n'importe quoi, une écriture peut échouer (quota) : tout est absorbé.
 */

export type SafeStorage = Pick<Storage, 'getItem' | 'setItem'>

export const getLocalStorage = (): Storage | undefined => {
  try {
    return globalThis.localStorage
  } catch {
    return undefined
  }
}

/** Valeur JSON stockée sous `key`, `undefined` si absente, illisible ou stockage indisponible. */
export function readStorageJson(storage: SafeStorage | undefined, key: string): unknown {
  try {
    const raw = storage?.getItem(key)
    if (raw === null || raw === undefined) return undefined
    return JSON.parse(raw) as unknown
  } catch {
    return undefined
  }
}

/**
 * Écrit `value` en JSON sous `key`. `false` : rien n'est gardé (stockage indisponible, écriture
 * refusée, quota) ; l'appelant qui en dépend peut se replier et le signaler.
 */
export function writeStorageJson(
  storage: SafeStorage | undefined,
  key: string,
  value: unknown,
): boolean {
  if (!storage) return false
  try {
    storage.setItem(key, JSON.stringify(value))
    return true
  } catch {
    return false
  }
}
